import { combineReducers } from 'redux';

import stagingReducer from './reducers/stagingReducer';
import curriculumReducer from './reducers/curriculumReducer';
import feedbackReducer from './reducers/feedbackReducer';
import soundReducer from './reducers/soundReducer';
import wordsReducer from './reducers/wordsReducer';

const unmaskThatCombinedReducers = combineReducers({
  staging: stagingReducer,
  curriculum: curriculumReducer,
  feedback: feedbackReducer,
  sound: soundReducer,
  words: wordsReducer,
});

export default unmaskThatCombinedReducers;
